import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NbCardComponent, NbCardModule } from "@nebular/theme";

@Component({
    selector: "ngx-error",
    templateUrl: "./error.component.html",
    styleUrls: ["./error.component.scss"],
    imports: [NbCardModule],
    standalone: true
})
/** Generic error screen shown for the `/error` route; offers a reload-back-to-home action. */
export class ErrorComponent {
  constructor(private router: Router) {}

  /** Navigates to the app root and reloads to recover from a faulted state. */
  goHome() {
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
  }
}
